import { useIntl } from 'react-intl'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MenuItem } from './MenuItem'
import { useAuth } from '../../../../../app/modules/auth/core/AuthProvider'

export function MenuInner() {
  const intl = useIntl()
  const { user } = useAuth()
  const canManageCompanyData = user?.permissions?.canManageCompanyData ?? false
  const canManageSiteData = user?.permissions?.canManageSiteData ?? false
  const canManageUsers = user?.permissions?.canManageUsers ?? false
  const canAccessDataExport = user?.permissions?.canAccessDataExport ?? false
  const canAccessDataFiles = user?.permissions?.canAccessDataFiles ?? false
  const canAccessDataView = user?.permissions?.canAccessDataView ?? false
  const canAccessDataReliability = user?.permissions?.canAccessDataReliability ?? false
  const showDataMenu =
    canAccessDataFiles || canAccessDataView || canAccessDataExport || canAccessDataReliability

  if (!canManageCompanyData) {
    return (
      <>
        <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />
        {canManageSiteData && (
          <MenuInnerWithSub
            title={intl.formatMessage({ id: 'MENU.COMPANY' })}
            to='company/sites'
            menuPlacement='bottom-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='company/sites' title={intl.formatMessage({ id: 'MENU.COMPANYSITES' })} />
            <MenuItem
              to='company/meters'
              title={intl.formatMessage({ id: 'MENU.COMPANYMETERS' })}
            />
          </MenuInnerWithSub>
        )}
        {canAccessDataExport && (
          <MenuItem title={intl.formatMessage({ id: 'MENU.DATAEXPORT' })} to='data_export/list' />
        )}
      </>
    )
  }

  return (
    <>
      <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />
      {canManageUsers ? (
        <MenuItem to='users/list' title={intl.formatMessage({ id: 'MENU.USERS' })} />
      ) : null}
      {canManageCompanyData && (
        <MenuInnerWithSub
          title={intl.formatMessage({ id: 'MENU.COMPANY' })}
          to='company/list'
          menuPlacement='bottom-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='company/list' title={intl.formatMessage({ id: 'MENU.COMPANYLIST' })} />
          <MenuItem to='company/sites' title={intl.formatMessage({ id: 'MENU.COMPANYSITES' })} />
          <MenuItem to='company/meters' title={intl.formatMessage({ id: 'MENU.COMPANYMETERS' })} />
        </MenuInnerWithSub>
      )}
      {showDataMenu && (
        <MenuInnerWithSub
          title={intl.formatMessage({ id: 'MENU.DATA' })}
          to={
            canAccessDataFiles
              ? 'data_files/list'
              : canAccessDataView
              ? 'data_view/list'
              : canAccessDataExport
              ? 'data_export/list'
              : 'data_reliability'
          }
          menuPlacement='bottom-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          {canAccessDataFiles && (
            <MenuItem title={intl.formatMessage({ id: 'MENU.DATAFILES' })} to='data_files/list' />
          )}
          {canAccessDataView && (
            <MenuItem title={intl.formatMessage({ id: 'MENU.DATAVIEW' })} to='data_view/list' />
          )}
          {canAccessDataExport && (
            <MenuItem title={intl.formatMessage({ id: 'MENU.DATAEXPORT' })} to='data_export/list' />
          )}
          {canAccessDataReliability && (
            <MenuItem
              title={intl.formatMessage({ id: 'MENU.DATARELIABILITY' })}
              to='data_reliability'
            />
          )}
        </MenuInnerWithSub>
      )}
    </>
  )
}
